import {useFormContext, useWatch} from "react-hook-form";
import {useTranslation} from "react-i18next";

export const WriteOffGoodsDetailFooter = () => {
    const {t} = useTranslation();
    const {watch} = useFormContext();

    const watchTotalAmount = watch("totalAmount");
    
    return (
        <>
            <b>Total amount:{watchTotalAmount}</b>
        </>
    )
}